import { render } from "./EnRules.vue?vue&type=template&id=2d06b974&scoped=true"
import script from "./EnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./EnRules.vue?vue&type=script&scoped=true&lang=js"

import "./EnRules.vue?vue&type=style&index=0&id=2d06b974&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d06b974"

export default script